module.exports = __webpack_public_path__ + "static/media/va-dap.83c18cb1.svg";